import React from 'react';
import { Spinner, Center } from '@gluestack-ui/themed';
import { useAuthStore } from '@/common/auth/store';
import { useTaskScreen } from './hooks/useTaskScreen';

/**
 * TaskScreen
 *
 * Screen-level container that owns the selected task data and orchestrates
 * layout selection and submission initialization.
 */
const TaskScreen: React.FC = () => {
  const isTrialStudent = useAuthStore((state) => Boolean(state.user?.trial?.isTrial));
  const {
    task,
    resources,
    thumbnails,
    isTasksLoading,
    selectedModule,
    taskIsGatedAndDone,
    conflict,
    TaskScreenLayout,
  } = useTaskScreen();
  const taskReadOnly = taskIsGatedAndDone || isTrialStudent;

  if (isTasksLoading || !task) {
    return (
      <Center flex={1} testID="loading-spinner" bg="$bgApp">
        <Spinner size="large" />
      </Center>
    );
  }

  return (
    <TaskScreenLayout
      key={task?.id}
      testID="task-screen-layout"
      task={task}
      resources={resources}
      thumbnails={thumbnails}
      courseId={selectedModule?.courseId || ''}
      moduleId={selectedModule?.moduleId || ''}
      readonly={taskReadOnly}
      isLoading={isTasksLoading}
      safetyFuseConflict={!!conflict}
    />
  );
};

export default TaskScreen;
